import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const SignSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17.3458 2.31748C17.6557 2.00759 18.076 1.8335 18.5142 1.8335C18.9525 1.8335 19.3728 2.00759 19.6827 2.31748C19.9926 2.62737 20.1667 3.04768 20.1667 3.48593C20.1667 3.92418 19.9926 4.34448 19.6827 4.65437L12.2825 12.0545L9.16667 12.8335L9.94564 9.71764L17.3458 2.31748Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.7807 14.1523C8.7807 14.1523 11.4804 16.8346 12.3488 16.8346C12.7831 16.8346 13.6516 16.5663 13.6516 15.4933C13.6516 14.4203 12.7831 14.4501 12.3488 14.5992C12.3488 14.5992 11.0465 15.0463 6.70425 16.3875C2.36195 17.7287 0.560807 11.8971 2.79636 11.9167C5.0319 11.9363 3.57866 16.3772 5.74122 18.1759C7.90378 19.9746 12.4436 19.0702 13.6516 18.623C14.8596 18.1759 18.3333 15.9404 18.3333 15.9404'
      stroke='currentColor'
      strokeLinecap='round'
    />
  </svg>
);

export const SignIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SignSvg} {...props} />
);
